import defaultErrorHandler from "actions/global/default-error-handler";
import { toast } from "react-toastify";
import moment from "moment";

import {
  requestAll,
  requestTemplates,
  requestZoneTypes,
  requestAdd
} from "actions/zone/requests";
import {
  ZONE_LOADING,
  ZONE_ERROR,

  ZONE_GET_LIST,
  ZONE_GET_ALL,
  ZONE_GET_TEMPLATES,
  ZONE_GET_FILTERS,
  ZONE_GET_TYPES,
  ZONE_ADD
} from "actions/zone/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";
import filterTypes from "../../data/filter-types";

export const setLoading = (status) => ({
  type: ZONE_LOADING,
  payload: status
});

export const getZoneList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  filters.push({
    fieldName: "end",
    fieldValue: moment()
      .valueOf(),
    searchOperation: filterTypes.MORE.value
  });
  requestCommonSearch("zones", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: ZONE_GET_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ZONE_ERROR));
    });
};

export const getZoneAll = () => dispatch => {
  dispatch(setLoading(true));
  requestAll()
    .then((response) => {
      dispatch({
        type: ZONE_GET_ALL,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ZONE_ERROR));
    });
};

export const getZoneTemplates = () => dispatch => {
  dispatch(setLoading(true));
  requestTemplates()
    .then((response) => {
      dispatch({
        type: ZONE_GET_TEMPLATES,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ZONE_ERROR));
    });
};

export const getZoneFilters = () => dispatch => {
  dispatch(setLoading(true));
    requestCommonFilters("zones")
    .then((response) => {
      dispatch({
        type: ZONE_GET_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ZONE_ERROR));
    });
};

export const getZoneTypes = () => dispatch => {
  dispatch(setLoading(true));
  requestZoneTypes()
    .then((response) => {
      dispatch({
        type: ZONE_GET_TYPES,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ZONE_ERROR));
    });
};

export const addZone = (data) => dispatch => {
  dispatch(setLoading(true));
  requestAdd(data)
    .then(response => {
      dispatch({
        type: ZONE_ADD,
        payload: response.data.content
      });
      toast("Operation successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ZONE_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/zone/actions.js